import { render, staticRenderFns } from "./CommonDisease.vue?vue&type=template&id=a5fbf6b8&scoped=true&"
import script from "./CommonDisease.vue?vue&type=script&lang=js&"
export * from "./CommonDisease.vue?vue&type=script&lang=js&"
import style0 from "./CommonDisease.vue?vue&type=style&index=0&id=a5fbf6b8&lang=scss&scoped=true&"
import style1 from "./CommonDisease.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fbf6b8",
  null
  
)

export default component.exports